import { connect } from 'react-redux';
import { Alert } from 'foundations-components/transitional/components/Alert';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getContentTypeLimit } from 'ContentEditorUI/redux/selectors/limitSelectors';
// @ts-expect-error: not typed yet
import { getPageLimitLangKey } from '../redux/selectors/pageLimitSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
const mapStateToProps = state => ({
  pageLimit: getContentTypeLimit(state),
  langKey: getPageLimitLangKey(state)
});
const LimitExceededError = ({
  pageLimit,
  langKey
}) => {
  var _pageLimit$pageLimit;
  return /*#__PURE__*/_jsx(Alert, {
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `limitExceededError.${langKey}.title`,
      options: {
        count: pageLimit.pageLimit,
        quantityUsed: pageLimit.quantityUsed
      }
    }),
    type: "danger",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `limitExceededError.${langKey}.message`,
      options: {
        count: pageLimit.quantityUsed - ((_pageLimit$pageLimit = pageLimit.pageLimit) !== null && _pageLimit$pageLimit !== void 0 ? _pageLimit$pageLimit : 0)
      }
    })
  });
};
export default connect(mapStateToProps)(LimitExceededError);